import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

import { ApplicantsTableDefinitionZod } from '../tables';

type Arguments = {
    applicantId: string;
    id: string;
    position?: number;
};
export const schemaLoanRequestResolver_GetPhoneLegitimation = ApplicantsTableDefinitionZod.shape.legitimation
    .removeDefault()
    .shape.telephone.or(z.array(z.never()));

export type SchemaLoanRequestResolver_GetPhoneLegitimation = z.infer<
    typeof schemaLoanRequestResolver_GetPhoneLegitimation
>;

export type LoanRequestResolver_GetPhoneLegitimation = Resolver<
    Arguments,
    SchemaLoanRequestResolver_GetPhoneLegitimation
>;
